export default "__VITE_ASSET__DZdObdFC__"